import React from "react";
import Typography from "material-ui-next/Typography";
import { DataTable, StyledButton } from "components/support";
import Paper from "material-ui-next/Paper";
import { LinearProgress } from "material-ui-next/Progress";
import PlayIcon from "material-ui/svg-icons/av/play-arrow";
import PauseIcon from "material-ui/svg-icons/av/pause";
import { toJS } from "mobx";
import { observer } from "mobx-react";
import * as Fields from "../fields";
import Icon from "material-ui-next/Icon";
import Tooltip from "material-ui-next/Tooltip";

const styles = {
  controller: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    alignItems: "center"
  }
};

const config = ({ errors, columns, stages, onChange }) => {
  const params = (props, fieldName) => {
    return {
      row: props.original,
      errors,
      stages: toJS(stages),
      onChange: value => onChange(props.original.index, fieldName, value)
    };
  };

  return {
    columns: [
      {
        accessor: "imported",
        Header: "Importado?",
        Cell: props => <Fields.ImportedField {...params(props)} />
      },
      {
        accessor: "code",
        Header: "Código",
        Cell: props => <Fields.CodeField {...params(props, "code")} />
      },
      {
        accessor: "name",
        Header: "Descrição",
        Cell: props => <Fields.NameField {...params(props, "name")} />
      },
      {
        accessor: "sell_value",
        Header: "Preço de Venda",
        Cell: props => (
          <Fields.SellValueField {...params(props, "sell_value")} />
        )
      },
      {
        accessor: "cost_value",
        Header: "Preço de Compra",
        Cell: props => (
          <Fields.CostValueField {...params(props, "cost_value")} />
        )
      },
      {
        accessor: "unit_label",
        Header: "Und. de Medida",
        Cell: props => (
          <Fields.UnitLabelField {...params(props, "unit_label")} />
        )
      },
      {
        accessor: "stock_count",
        Header: "Qtd. em Estoque",
        Cell: props => (
          <Fields.StockCountField {...params(props, "stock_count")} />
        )
      },
      {
        accessor: "restock_count",
        Header: "Estoque Mínimo",
        Cell: props => (
          <Fields.RestockCountField {...params(props, "restock_count")} />
        )
      },
      {
        accessor: "category",
        Header: "Categoria",
        Cell: props => <Fields.CategoryField {...params(props, "category")} />
      },
      {
        accessor: "cest",
        Header: "CEST",
        Cell: props => <Fields.CestField {...params(props, "cest")} />
      },
      {
        accessor: "cfop",
        Header: "CFOP",
        Cell: props => <Fields.CfopField {...params(props, "cfop")} />
      },
      {
        accessor: "ncm",
        Header: "NCM",
        Cell: props => <Fields.NcmField {...params(props, "ncm")} />
      },
      {
        accessor: "csosn",
        Header: "CSOSN",
        Cell: props => <Fields.CsosnField {...params(props, "csosn")} />
      },
      {
        accessor: "barcode",
        Header: "Código de Barras",
        Cell: props => <Fields.BarcodeField {...params(props, "barcode")} />
      },
      {
        accessor: "pis",
        Header: () => (
          <Tooltip
            key="tooltip-top-pis"
            title="Para utilizar a configuração geral da empresa, não informe PIS, COFINS e Origem"
            placement="top"
          >
            <div>
              PIS
              <Icon
                style={{
                  fontSize: 16,
                  color: "white",
                  marginLeft: "4px",
                  position: "absolute",
                  top: "11px"
                }}
              >
                info
              </Icon>
            </div>
          </Tooltip>
        ),
        Cell: props => <Fields.PisField {...params(props, "pis")} />
      },
      {
        accessor: "cofins",
        Header: () => (
          <Tooltip
            key="tooltip-top-cofins"
            title="Para utilizar a configuração geral da empresa, não informe PIS, COFINS e Origem"
            placement="top"
          >
            <div>
              COFINS
              <Icon
                style={{
                  fontSize: 16,
                  color: "white",
                  marginLeft: "4px",
                  position: "absolute",
                  top: "11px"
                }}
              >
                info
              </Icon>
            </div>
          </Tooltip>
        ),
        Cell: props => <Fields.CofinsField {...params(props, "cofins")} />
      },
      {
        accessor: "origin",
        Header: () => (
          <Tooltip
            key="tooltip-top-origin"
            title="Para utilizar a configuração geral da empresa, não informe PIS, COFINS e Origem"
            placement="top-start"
          >
            <div>
              ORIGEM
              <Icon
                style={{
                  fontSize: 16,
                  color: "white",
                  marginLeft: "4px",
                  position: "absolute",
                  top: "11px"
                }}
              >
                info
              </Icon>
            </div>
          </Tooltip>
        ),
        Cell: props => <Fields.OriginField {...params(props, "origin")} />
      }
    ]
  };
};

const BatchQueue = ({
  rows,
  columns,
  errors,
  stages,
  headers,
  started,
  onStart,
  onStop,
  progress,
  perPage,
  page,
  onPageChange,
  onChange
}) => {
  const rowsSlice = rows.slice((page - 1) * perPage, page * perPage);

  return (
    <Paper elevation={1} className="p-sm mb-md">
      <Typography type="headline">3ª Etapa</Typography>
      <div style={styles.controller}>
        {!started && (
          <StyledButton
            secondary
            label="Iniciar"
            onClick={() => onStart(rows)}
            leftIcon={<PlayIcon style={{ fill: "#FFF" }} />}
          />
        )}
        {started && (
          <StyledButton
            flat
            label="Pausar"
            onClick={() => onStop()}
            leftIcon={<PauseIcon />}
          />
        )}
      </div>

      {started && (
        <LinearProgress
          style={{ margin: "8px -8px -8px -8px" }}
          mode="determinate"
          value={progress}
        />
      )}

      <div style={{ margin: "8px -8px -8px -8px" }}>
        <DataTable
          manual
          resultSet={rowsSlice}
          config={config({ errors, columns, stages, onChange })}
          perPage={perPage}
          page={page}
          total={rows.length}
          onPageChange={page => onPageChange(page + 1)}
        />
      </div>
    </Paper>
  );
};

export default observer(BatchQueue);



// WEBPACK FOOTER //
// ./src/components/app/registration/product/batch/queue/index.js